import React, { useEffect, useRef } from 'react';
import { bool } from 'prop-types';
import { StyledMenu } from './Menu.styled';
import { withRouter, Link } from 'react-router-dom';

const Menu = ({ open, setOpen, burgerRef, ...props }) => {

  const isHidden = open ? true : false;
  const tabIndex = isHidden ? 0 : -1;

  const ref = useRef(null);

  const handleHideDropdown = (event) => {
    if (event.key === 'Escape') {
      setOpen(false);
    }
  };

  const handleClickOutside = (event) => {
    if (burgerRef && burgerRef.current) {
      if (ref.current && !ref.current.contains(event.target) && event.target !== burgerRef.current) {
        setOpen(false);
      }
    } else {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    }
  };

  const checkLinkClicked = (event) => {
    if (
      ref.current
      && ref.current.contains(event.target)
      && event.target.nodeName === 'A'
    ) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleHideDropdown, true);
    document.addEventListener('click', handleClickOutside, true);
    document.addEventListener('scroll', handleClickOutside, true);
    return () => {
      document.removeEventListener('keydown', handleHideDropdown, true);
      document.removeEventListener('click', handleClickOutside, true);
      document.removeEventListener('scroll', handleClickOutside, true);
    };
  });


  return (
    <StyledMenu ref={ref} open={open} aria-hidden={!isHidden} onClick={checkLinkClicked} {...props}>
      <Link to="/" tabIndex={tabIndex}>
        <span aria-hidden="true"></span>
        Home
      </Link>
      <Link to="/About" tabIndex={tabIndex}>
        <span aria-hidden="true"></span>
        About
      </Link>
      <Link to="/Team" tabIndex={tabIndex}>
        <span aria-hidden="true"></span>
        Team
        </Link>
      <a href="http://bf-study-app.cs.sfu.ca" target="_blank" rel="noreferrer" tabIndex={tabIndex}>
        <span aria-hidden="true"></span>
        Learn Blackfoot
      </a>
      <Link to="/TTS" tabIndex={tabIndex}>
        <span aria-hidden="true"></span>
        Text To Speech
        </Link>
      <Link to="/Robot" tabIndex={tabIndex}>
        <span aria-hidden="true"></span>
        Robotics
        </Link>
      <Link to="/Chatbots" tabIndex={tabIndex}>
        <span aria-hidden="true"></span>
        Student Chatbots
      </Link>
      <Link to="/TeachingResources" tabIndex={tabIndex}>
        <span aria-hidden="true"></span>
        Teaching Resources
      </Link>
      <a href="https://www.surveymonkey.ca/r/N6XBHLY" target="_blank"  rel="noreferrer"  tabIndex={tabIndex}>
        <span aria-hidden="true"></span>
        Provide Feedback
      </a>
    </StyledMenu>
  );
}

Menu.propTypes = {
  open: bool.isRequired,
}

export default withRouter(Menu);
